import { Collection } from "@src/types/CollectionListResponse";
import { CollectionMenuItem } from "@src/types/models";
import { ShareVia } from "../Share/utils/utils";
import { showToast, ToastTypes } from "../VDBToast/util";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

export type CollectionProps = {
  testID?: string;
  collection?: Collection;
  isFavorites?: boolean;
  count?: number;
  stock_item_ids?: any;
  threeDotOptions?: any;
  menuOptions?: Array<CollectionMenuItem>;
  shareOptions?: Array<CollectionMenuItem>;
  fromFavoriteScreen?: boolean;
  showCheckbox?: boolean;
  checkboxFunction?: any;
  selectCheckbox?: boolean;
  showSelected: boolean;
};

export const menuOptionSelected = (
  eventName: string,
  setshowShareModal: any,
  setSelectedOption: any,
  count?: number,
  collection?: Collection,
  isFavorites?: boolean,
  t?: any
) => {
  const handleEmptyOrExcess = (isEmpty: boolean, isExcess: boolean) => {
    if (isEmpty) {
      showToast(
        undefined,
        isFavorites
          ? t("favoritesList.emptyFavorties.toast.text")
          : t("favoritesList.emptyCollections.toast.text"),
        ToastTypes.ERROR,
        true,
        true,
        undefined,
        () => {},
        true,
        7000
      );
    } else if (isExcess) {
      showToast(
        undefined,
        isFavorites
          ? t("favoritesList.excessFavorties.toast.text")
          : t("favoritesList.excessCollection.toast.text"),
        ToastTypes.ERROR,
        true,
        true,
        undefined,
        () => {},
        true,
        7000
      );
    } else {
      setshowShareModal(true);
    }
  };

  const isEmpty =
    (typeof count === "number" && count === 0) ||
    (typeof collection?.count === "number" && collection.count === 0);

  const isExcess =
    (typeof count === "number" && count >= 50) ||
    (typeof collection?.count === "number" && collection?.count >= 50);

  switch (eventName) {
    case SearchResultsAndFavoritesEnum.SHARE_EMAIL:
      setSelectedOption(ShareVia.EMAIL);
      handleEmptyOrExcess(isEmpty, isExcess);
      break;
    case SearchResultsAndFavoritesEnum.SHARE_NATIVE:
      setSelectedOption(ShareVia.NATIVE);
      handleEmptyOrExcess(isEmpty, isExcess);
      break;
    case SearchResultsAndFavoritesEnum.SHARE_VIA_LINK:
      setSelectedOption(ShareVia.LINK);
      handleEmptyOrExcess(isEmpty, isExcess);
      break;
    default:
      break;
  }
};
